import { Copy } from "@/copy/copy";

/**
 * Transaction-only views (the Sankey, merchants, subscriptions, spending against the 12-month
 * average, sorting transactions) need bank connections, which aren't built yet; Assets' returns,
 * asset classes, and holdings need investment connections (`sub` says so).
 */
export function ConnectEmpty({ what, sub }: { what?: string; sub?: string }) {
  return (
    <div className="wp-connect" data-testid="connect-empty">
      <span className="ic" aria-hidden="true">
        🏦
      </span>
      <div>
        <Copy k="plan.connectTitle" as="b" />
        {what && (
          <p className="mut" style={{ margin: "4px 0 0" }}>
            {what}
          </p>
        )}
        {sub ? <p className="mut">{sub}</p> : <Copy k="plan.connectSub" as="p" className="mut" />}
        <button type="button" className="mini" disabled>
          Connect your accounts &middot; coming soon
        </button>
      </div>
    </div>
  );
}
